import { render, staticRenderFns } from "./MaintenanceComponent.vue?vue&type=template&id=d891d0be"
import script from "./MaintenanceComponent.vue?vue&type=script&lang=js"
export * from "./MaintenanceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d891d0be')) {
      api.createRecord('d891d0be', component.options)
    } else {
      api.reload('d891d0be', component.options)
    }
    module.hot.accept("./MaintenanceComponent.vue?vue&type=template&id=d891d0be", function () {
      api.rerender('d891d0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/asset-governance/pages/MaintenanceComponent.vue"
export default component.exports